/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import {
  Dialog,
  Button,
  CustomCheckBox,
  TextInput,
  Image,
  Anchor,
} from "hesus-ui-kit";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import RelatedContactView from "../RelatedContactView/RelatedContactView";
import errorIcon from "@icons/ic-error.svg";
import closeIcon from "@icons/ic-close-white.svg";
import Contact from "./components/Contact/Contact";
import AddEditContact from "../../Contact/AddEditContact/AddEditContact";
import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
} from "@utils/extra-style";

import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  FormBody,
  OptionsWrapper,
  FlexRow,
  SectionContainer,
  GridRow,
  ContainerLabel,
  RequiredMessage,
  ErrorDiv,
  GridRowLink,
} from "./AddEditRelatedContact.styled";

const AddEditRelatedContact = (props) => {
  const {
    t,
    id,
    isEditMode,
    isViewMode,
    title,
    onClose,
    togglePopUp,
    updateRefeshStatus,
    companyId,
    parents,
    entityType,
    entityId,
    contactStatus,
    onAddForCreate,
    dependancies,
    countryId,
  } = props;

  const [isContactCreating, setIsContactCreating] = useState(false);
  const [isAddEditRelatedConatct, setIsAddEditRelatedConatct] = useState(true);
  const [isAddConatct, setIsAddConatct] = useState(false);
  const [createContactAPIError, setCreateContactAPIError] = useState("");
  const relatedContactListByIds = useSelector(
    (state) => state.relatedContactList.byId
  );
  const generalParams = useGetGeneralParameters();
  const contactOperationalTypeList = generalParams.contactOperationalType;

  const [checkedRoles, setCheckedRoles] = useState([]);

  const selectedRelatedContact = relatedContactListByIds[id];

  const [formData, setFormData] = useState({
    contact: {
      required: true,
      value: selectedRelatedContact?.contact ?? "",
      error: "",
    },
    job: {
      required: false,
      value: selectedRelatedContact?.role ?? "",
      error: "",
    },
    roles: {
      required: false,
      value: selectedRelatedContact?.relatedContactRoles ?? [],
      error: "",
    },
  });

  const OnJobChange = (e) => {
    setFormData({
      ...formData,
      job: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  const onRoleChange = (e, checkedRoleId) => {
    const jobValue = e.target.checked;
    if (!jobValue) {
      const checkedRolesInitial = [];
      for (let i = 0; i < checkedRoles.length; i++) {
        if (checkedRoleId !== checkedRoles[i]) {
          checkedRolesInitial.push(checkedRoles[i]);
        }
      }
      setCheckedRoles(checkedRolesInitial);
      setFormData({
        ...formData,
        roles: {
          value: checkedRolesInitial,
          error: "",
          required: true,
        },
      });
    } else {
      setCheckedRoles((checkedRoles) => [...checkedRoles, checkedRoleId]);
      setFormData({
        ...formData,
        roles: {
          value: [...checkedRoles, checkedRoleId],
          error: "",
          required: true,
        },
      });
    }
  };

  useEffect(() => {
    if (isEditMode) {
      let checkedRolesInitial = [];
      if (formData.roles.value.length > 0) {
        formData.roles.value.map((data) => {
          checkedRolesInitial.push(parseInt(data.roleId, 10));
        });
        setCheckedRoles(checkedRolesInitial);
      }
    }
  }, [isEditMode]);

  const openViewPopUp = () => {
    setIsAddConatct(true);
    setIsAddEditRelatedConatct(false);
  };

  const toogleViewPopUp = () => {
    setIsAddConatct(false);
    setIsAddEditRelatedConatct(true);
  };

  const validateForm = (data) => {
    let isFormValid = true;
    if (!data.contact?.value?.id) {
      isFormValid = false;
      data.contact.error = t("CONTACT_REQUIRED");
    }
    if (checkedRoles.length === 0) {
      isFormValid = false;
      data.roles.error = t("CONTACT_TYPE_REQUIRED");
    }
    if (!isFormValid) {
      setFormData({ ...data });
    }
    return isFormValid;
  };

  const getFormData = () => {
    let rolesData = [];
    for (let i = 0; i < checkedRoles.length; i++) {
      rolesData.push({
        roleId: checkedRoles[i],
      });
    }
    const data = {
      id: isEditMode ? selectedRelatedContact.id : "",
      relatedContactRoles: rolesData,
      entityId,
      entityType,
      role: formData.job.value,
      contact: formData.contact.value,
      status: true,
    };
    return data;
  };

  const onSubmitForCreate = () => {
    const isFormValid = validateForm(formData);
    if (isFormValid) {
      onAddForCreate(getFormData());
      onClose();
    }
  };

  const onSubmit = () => {
    const isFormValid = validateForm(formData);
    if (isFormValid) {
      setIsContactCreating(true);
      setCreateContactAPIError("");
      // Create solution
      if (!id && !isEditMode) {
        axios
          .post("/relatedContacts", getFormData())
          .then(() => {
            setIsContactCreating(false);
            updateRefeshStatus();
            onClose();
          })
          .catch((error) => {
            setIsContactCreating(false);
            setCreateContactAPIError(error.response?.data?.message ?? "");
          });
      }
      // Edit
      if (id && isEditMode) {
        axios
          .put(`/relatedContacts/${id}`, getFormData())
          .then(() => {
            setIsContactCreating(false);
            updateRefeshStatus();
            onClose();
          })
          .catch((error) => {
            setIsContactCreating(false);
            setCreateContactAPIError(error.response?.data?.message ?? "");
          });
      }
    }
  };

  const onEdit = () => {
    togglePopUp();
  };

  return (
    <>
      {isAddConatct && (
        <AddEditContact
          title={t("Contact")}
          onClose={toogleViewPopUp}
          page="relatedContact"
          companyId={companyId}
          countryId={countryId}
        />
      )}
      {isAddEditRelatedConatct && (
        <Dialog width={isViewMode ? "55rem" : "35rem"} zIndex="99">
          <div>
            <HeaderWrapper>
              <Title>{title}</Title>
              <Button
                onClick={onClose}
                styles={{
                  backgroundColor: "transparent",
                  border: "none",
                  height: "auto",
                  padding: 0,
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                <Image
                  src={closeIcon}
                  alt="close popup"
                  styles={{ width: "auto" }}
                />
              </Button>
            </HeaderWrapper>

            {isViewMode && (
              <RelatedContactView relatedContactInfo={selectedRelatedContact} />
            )}
            {!isViewMode && isAddEditRelatedConatct && (
              <>
                <FormBody>
                  <OptionsWrapper>
                    <FlexRow>
                      <SectionContainer>
                        <div>
                          <GridRow column="1fr">
                            <div>
                              <Contact
                                formData={formData}
                                setFormData={setFormData}
                                isEditMode={isEditMode}
                                selectedRelatedContact={selectedRelatedContact}
                                companyId={companyId}
                                parents={parents}
                                setCheckedRoles={setCheckedRoles}
                                dependancies={dependancies}
                                countryId={countryId}
                              />
                            </div>
                          </GridRow>
                          <GridRow column="1fr">
                            <TextInput
                              type="text"
                              id="contact-job"
                              isFloat
                              value={formData?.job?.value}
                              label={t("CONTACT_FUNCTION")}
                              containerStyles={{ marginTop: "21px" }}
                              errorStyles={{ "font-style": "italic" }}
                              labelStyles={
                                formData.job.error !== ""
                                  ? labelStylesError
                                  : labelStyles
                              }
                              inputStyles={
                                formData.job.error !== ""
                                  ? inputStylesError
                                  : inputStyles
                              }
                              onChange={(e) => OnJobChange(e)}
                              error={formData.job.error}
                              placeholder={t("CONTACT_FUNCTION")}
                            />
                          </GridRow>
                          <GridRow column="1fr">
                            <ContainerLabel>{t("CONTACT_TYPE")}</ContainerLabel>
                          </GridRow>
                          <GridRow column="1fr 1fr 1fr">
                            {contactOperationalTypeList?.map((contactType) => (
                              <CustomCheckBox
                                key={"related-contact_" + contactType.value}
                                id={contactType.value}
                                labelText={t(contactType.label)}
                                dataId={contactType.value}
                                onChange={(e) => {
                                  onRoleChange(
                                    e,
                                    parseInt(contactType.value, 10)
                                  );
                                }}
                                checked={
                                  checkedRoles.indexOf(contactType.value) !== -1
                                }
                              />
                            ))}
                          </GridRow>
                          {formData.roles.error !== "" && (
                            <GridRow column="1fr">
                              <ErrorDiv>
                                <RequiredMessage>
                                  <Image
                                    src={errorIcon}
                                    alt="warning"
                                    styles={{ width: "18px" }}
                                  />
                                  {formData.roles.error}
                                </RequiredMessage>
                              </ErrorDiv>
                            </GridRow>
                          )}
                        </div>
                      </SectionContainer>
                    </FlexRow>
                  </OptionsWrapper>
                </FormBody>

                <GridRowLink column="1fr">
                  <Anchor
                    clickAction={openViewPopUp}
                    styles={{
                      textDecoration: "underline !important",
                      color: "#004c7f !important",
                      cursor: "pointer",
                    }}
                  >
                    {t("CREATE_NEW_CONTACT")}
                  </Anchor>
                </GridRowLink>
              </>
            )}
            <ButtonWrapper>
              {createContactAPIError && <div>{createContactAPIError}</div>}

              <Button
                styles={{
                  color: "#333",
                  background: "#fff",
                  border: "1px solid #ccc",
                  marginRight: "0.32rem",
                  "&:hover": {
                    backgroundColor: "#ccc",
                  },
                }}
                onClick={onClose}
              >
                {t("CLOSE")}
              </Button>
              {!isViewMode && entityId && (
                <Button
                  styles={{
                    color: "white",
                    background: "#1BACE4",
                    border: "1px solid #1BACE4",
                    marginRight: "0.32rem",
                    "&:hover": {
                      backgroundColor: "#1589b6",
                    },
                  }}
                  onClick={onSubmit}
                >
                  <>
                    {isContactCreating && <ClipLoader size={15} color="#fff" />}
                    {!isContactCreating && t("SUBMIT")}
                  </>
                </Button>
              )}
              {!isViewMode && !entityId && (
                <Button
                  styles={{
                    color: "white",
                    background: "#1BACE4",
                    border: "1px solid #1BACE4",
                    marginRight: "0.32rem",
                    "&:hover": {
                      backgroundColor: "#1589b6",
                    },
                  }}
                  onClick={onSubmitForCreate}
                >
                  <>
                    {isContactCreating && <ClipLoader size={15} color="#fff" />}
                    {!isContactCreating && t("SUBMIT")}
                  </>
                </Button>
              )}
              {isViewMode && contactStatus === 1 && (
                <Button
                  styles={{
                    color: "white",
                    background: "#1BACE4",
                    border: "1px solid #1BACE4",
                    marginRight: "0.32rem",
                    "&:hover": {
                      backgroundColor: "#1589b6",
                    },
                  }}
                  onClick={onEdit}
                >
                  {t("EDIT")}
                </Button>
              )}
            </ButtonWrapper>
          </div>
        </Dialog>
      )}
    </>
  );
};

AddEditRelatedContact.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
  title: PropTypes.string.isRequired,
  isEditMode: PropTypes.bool,
  isViewMode: PropTypes.bool,
  updateRefeshStatus: PropTypes.func.isRequired,
  onAddForCreate: PropTypes.func,
  dependancies: PropTypes.string,
  countryId: PropTypes.number,
};

AddEditRelatedContact.defaultProps = {
  id: null,
  isEditMode: false,
  isViewMode: false,
  onAddForCreate: null,
  dependancies: "",
  countryId: null,
};
export default withTranslation()(AddEditRelatedContact);
